import CountryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import CountryText from "../atoms/CountryText/CountryText";

import FallbackLocationCell from "./FallbackLocationCell";
import RegionCell from "./RegionCell/RegionCell";
import RegionCellText from "./RegionCell/RegionCellText";
import SingleCountryCell from "./SingleCountryCell/SingleCountryCell";

type Props = { locationCode: number | null | undefined };

const LocationCell = ({ locationCode }: Props) => {
    if (!locationCode || CountryService.isUnknownCountry(locationCode)) {
        return <FallbackLocationCell />;
    }

    if (locationCode > WORLDWIDE_COUNTRY_ID) {
        return (
            <RegionCell>
                <RegionCellText regionCode={locationCode} />
            </RegionCell>
        );
    }

    return (
        <SingleCountryCell countryCode={locationCode}>
            <CountryText countryCode={locationCode} />
        </SingleCountryCell>
    );
};

export default LocationCell;
